import React from 'react';
import PropTypes from 'prop-types';
import './AngularLearn.scss';

const AngularLearn = () => {
  return (
    <div className="AngularLearn">
      <div className="main-right-side-section">
        <div className="angular-inner-section">
          <p className='font-Poppins text-6xl font-bold text-Primary'>This is Angular</p>
        </div>
      </div>
    </div>
  );
}

AngularLearn.propTypes = {};

AngularLearn.defaultProps = {};

export default AngularLearn;
